import { useEffect } from "react"
import { useSelector } from "react-redux"
import { useNavigate, useSearchParams } from "react-router-dom"

import { selectToken } from "./reducer"

export function useRedirectLoggedInUser() {
  const token = useSelector(selectToken)
  const searchParams = useSearchParams()[0]
  const navigate = useNavigate()

  useEffect(
    () => {
      // waiting on the token to be set from dispatched token received action
      if (token) {
        // "/" picks the role's landing page once the profile loads; an
        // explicit ?next= (e.g. a deep link that bounced to log-in) wins.
        const next = searchParams.get("next") || "/"
        navigate(next)
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [token]
  )
}
